export default "__VITE_ASSET__XUJkmycl__"